export const appsAppGroupIdChartsRevenuePreviousWindow = "/apps/:app_group_id/charts/revenue_previous_window";
